import React, { useEffect, useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";

import request from "graphql-request";
import { useAuth } from "../../../context/AuthContext/AuthContextProvider";
import { useLoading } from "../../../context/LodingContext";
import BASEURL from "../../Utils/Baseurl";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Card, CardHeader, Stack } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import PageLoading from "../../../components/Loading/PageLoading";
import {
  allAppointment,
  allVisit,
  getAppointmentDetailByMaster,
  getAppointmentDetailByUser,
} from "../callQuery";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import TableComponent from "../../../components/GridTable/TableComponent";

const Appointment = () => {
  const [appointmentData, setApointmentData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const isUser = currentUser?.role;
  const [row, setrow] = useState([]);
  const { circleLoading, setCirleLoading } = useLoading();

  const fetchVisitData = () => {
    setIsLoading(true);
    request(BASEURL, allVisit).then((res) => {
      setApointmentData(res.allVisit);
      console.log(res.allVisit, "ressponse");
      setrow(res.allVisit);
    })
    .finally(() => {
      setIsLoading(false);
    });
    
  };
  useEffect(() => {
    fetchVisitData();
  }, []);

  const visitListTable = {
    columns: [
      {
        label: "S.No",
        field: "sno",
        name: "S.NO",
        // flex: 1,
        width: 100,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Visit Log ID",
        field: "vlgid",
        name: "Visit Log ID",
        flex: 1,
        // width: 150,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: " Visited Date",
        field: "visiteddate",
        name: "Date",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: " Visited Time",
        field: "visitedtime",
        name: "Time",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Contact Person",
        field: "name",
        name: "Name",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Phone Number",
        field: "phoneNumber",
        name: "Phone Number",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      
      {
        label: "Created By",
        field: "createdBy",
        name: "Created By",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Created At",
        field: "createdAt", // This is the field name you defined in your table columns
        name: "Created At",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: appointmentData.sort((a, b) => b.id - a.id).map((val, index) => ({
      sno: index + 1,
      id: val.id,
      vlgid: val.vlgid,
      visiteddate: val.visiteddate,
      visitedtime: val.time,
      name: val.contactPerson,
      phoneNumber: val.phoneNumber,
      createdAt: val.createdAt.slice(0,10),
      createdBy: val.user.username,
    })),
  };

  const handleAddAppointmentForm = () => {
    navigate("/visitdetails/add-visit");
  };

  const onAppointmentForm = (e) => {
    if (e?.id) {
      navigate(`/visitdetails/add-visit?${e?.id}`);
    }
  };
  const onCheck=(list)=>
    {
      console.log("id-c",list)
    }
    
  const onDeleteALL=()=>
    {
      console.log("id-DELE")
    }

  return (
    <DashboardLayout>
     <TableComponent
     tableLoading={isLoading ? true : false}
     columns={visitListTable.columns}
     rowsData={visitListTable.rows}
     head="Visit List"
     actions={true}
     checked={false}
     view={true}
     showAdd = {true}
     onCheck={onCheck}
     onEdit={onAppointmentForm}
     // onDelete={onDelete}
     onView={onAppointmentForm}
     onDeleteALL={onDeleteALL}
     addList={() => handleAddAppointmentForm()}
     />
    </DashboardLayout>
  );
};

export default Appointment;
